// Collapse the entire top chrome (tab strip + toolbar + bookmarks bar) to give
// the content the full window; a small pull tab at the top reopens it. The
// state is remembered across reloads.
import { get, set } from "../shared/settings-store.js";
import { $ } from "./dom.js";

export function applyCollapse() {
	const root = document.querySelector(".rv-root");
	const on = !!get("chromeCollapsed");
	if (root) root.classList.toggle("collapsed", on);
	const pt = $("rv-pulltab"); if (pt) pt.hidden = !on;
	const cb = $("rv-collapse"); if (cb) cb.setAttribute("aria-pressed", on ? "true" : "false");
}

export function toggleCollapse() { set("chromeCollapsed", !get("chromeCollapsed")); applyCollapse(); }

export function initCollapse() {
	const cb = $("rv-collapse"); if (cb) cb.addEventListener("click", toggleCollapse);
	const pt = $("rv-pulltab"); if (pt) pt.addEventListener("click", toggleCollapse);
	applyCollapse();
}
